module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_f_melanistic.5a338914.png";